import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 售后订单模块基础路径（一期版本固定 v1）
const PREFIX = `${baseUrl}/joins-sales-cloud/v1/afterSale`;

// 1.1 中台报单页-报售后（MAIN_ORDER）
export const createFromDeclaration = (data) =>
  request({
    url: `${PREFIX}/createFromDeclaration`,
    method: 'POST',
    data
  });

// 1.2 中台手动新建售后（MANUAL）
export const createManual = (data) =>
  request({
    url: `${PREFIX}/createManual`,
    method: 'POST',
    data
  });

// 1.3 小程序通用码-发起售后（QR_COMMON）
export const createByCommonQr = (data) =>
  request({
    url: `${PREFIX}/createByCommonQr`,
    method: 'POST',
    data
  });

// 1.4 小程序一户一码-发起售后（QR_ONE_HOUSE）
export const createByHouseCode = (data) =>
  request({
    url: `${PREFIX}/createByHouseCode`,
    method: 'POST',
    data
  });

// 1.5 按主订单查关联售后单
export const listByParent = (parentId) =>
  request({
    url: `${PREFIX}/listByParent?parentId=${parentId}`,
    method: 'GET'
  });

// 1.6 中台售后订单列表（分页，page 从 0 开始）
export const getAfterSaleList = (params) => {
  params = parseParam(params);
  return request({
    url: `${PREFIX}/list?` + params,
    method: 'GET'
  });
};

// 1.7 售后订单详情（含原单）
export const getAfterSaleDetail = (id) =>
  request({
    url: `${PREFIX}/detail?id=${id}`,
    method: 'GET'
  });

// 1.8 作废售后订单
export const cancelAfterSale = (data) =>
  request({
    url: `${PREFIX}/cancel`,
    method: 'POST',
    data
  });

// 1.9 指派工程师（待指派 -> 待受理）
export const assignAfterSale = (data) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/afterSale/fulfillment/dispatch`,
    method: 'POST',
    data
  });

// 1.10 售后实际用料清单（未提交过实际用料时返回空数组）
export const getFulfillmentMaterials = (afterSaleId) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/afterSale/fulfillment/materials?afterSaleId=${afterSaleId}`,
    method: 'GET'
  });

// 1.11 售后工单反审核（待评价/已完成 -> 待终审，冲正材料账户与工费打款）
export const reverseAuditAfterSale = (afterSaleId) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/afterSale/fulfillment/reverseAudit`,
    method: 'POST',
    data: `afterSaleId=${encodeURIComponent(afterSaleId)}`,
    ContentType: 'application/x-www-form-urlencoded'
  });
